/* eslint-disable import/prefer-default-export */
export const namespace = 'features.deficiencies.show';
